const TabButton = ({ children, index, value, setValue, id = '', onClick, injectClass }) => {

    const handleClick = () => {
        if (typeof setValue === 'function') setValue(index)
        if (typeof onClick === 'function') onClick()
    }

    return (
        <button className={`mx-2 py-0.5 font-medium rounded transition-all duration-150 ${index === value ? `text-black dark:bg-ldark px-4 ${injectClass ? injectClass : 'text-primeColor underline font-bold text-2xl'}` : 'text-black text-xl'} outline-none focus:outline-none`} onClick={handleClick} id={id}>
            {children}
        </button >
    )
}

export default TabButton